import { qportalApi } from './qportal-api';
const downloadFile = (folderName, fileName) => {
    return qportalApi.get(`Storage/${encodeURIComponent(folderName)}/${encodeURIComponent(fileName)}`);
};
const FileApi = {
    downloadFile
};
export default FileApi;
